import React from 'react';
import { ChevronLeftSmall as ChevronLeftSmallCE } from '@wix/wix-ui-icons-common/classic-editor';
import { ChevronLeftSmall as ChevronLeftSmallRE } from '@wix/wix-ui-icons-common/responsive-editor';
import { WixBaseUiEnvironmentContext } from '../../../util/WixBaseUiEnvironment/WixBaseUiEnvironment';
import { iconColorByEditor } from '../iconsColors';
var ChevronLeftSmall = function ChevronLeftSmall(_ref) {
  var color = _ref.color;
  var context = React.useContext(WixBaseUiEnvironmentContext);
  var iconColor = '';
  if (color && (iconColorByEditor["".concat(color, "-RE")] || iconColorByEditor["".concat(color, "-CE")])) {
    iconColor = (context === null || context === void 0 ? void 0 : context.theme) === 'responsive' ? iconColorByEditor["".concat(color, "-RE")] : iconColorByEditor["".concat(color, "-CE")];
  }
  return (context === null || context === void 0 ? void 0 : context.theme) === 'responsive' ? /*#__PURE__*/React.createElement(ChevronLeftSmallRE, {
    color: iconColor
  }) : /*#__PURE__*/React.createElement(ChevronLeftSmallCE, {
    color: iconColor
  });
};
ChevronLeftSmall.displayName = 'ChevronLeftSmall';
export default ChevronLeftSmall;